<template>
  <main v-if="data?.airport" class="container">
    <div class="row">
      <div class="col-12 col-xs-10 col-md-12 col-lg-10 col-xl-8 col-xxl-7 mx-auto mt-4 mt-md-5">
        <div class="d-flex align-items-center">
          <h1 class="h2">
            Vluchten vanaf {{ data.airport.city.name_nl }} ({{ data.airport.iata }})
          </h1>
        </div>
        <p class="mb-2">
          {{ data.airport.name }} ({{ data.airport.iata }})
        </p>
        <div
          v-if="data.airport.excerpt"
          class="small mb-2"
          v-html="data.airport.excerpt"
        ></div>
        <div class="row">
          <div class="col-12 mt-3">
            <h2 class="h6 small fw-bold text-uppercase text-primary mb-3">
              Over {{ data.airport.name }}
            </h2>
            <div class="row g-2 mb-3">
              <div class="col-4">
                <div class="card no-hover p-3 bg-blurry">
                  <p class="mb-1 small text-uppercase opacity-75">Land</p>
                  <p class="mb-0 fw-bold mb-n1">{{ data.airport.city.country.name_nl }}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="card no-hover p-3 bg-blurry">
                  <p class="mb-1 small text-uppercase opacity-75">Stad</p>
                  <p class="mb-0 fw-bold mb-n1">{{ data.airport.city.name_nl }}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="card no-hover p-3 bg-blurry">
                  <p class="mb-1 small text-uppercase opacity-75">Continent</p>
                  <p class="mb-0 fw-bold mb-n1">{{ data.airport.city.country.continent }}</p>
                </div>
              </div>
              <div class="col-6">
                <div class="card no-hover p-3 bg-blurry">
                  <p class="mb-1 small text-uppercase opacity-75">Luchthaven Lounges</p>
                  <p class="mb-0 fw-bold mb-n1">{{ data.airport.lounges }} lounges</p>
                </div>
              </div>
              <div class="col-6">
                <div class="card no-hover p-3 bg-blurry">
                  <p class="mb-1 small text-uppercase opacity-75">Start- en landingsbanen</p>
                  <p class="mb-0 fw-bold mb-n1">{{ data.airport.runways }} banen</p>
                </div>
              </div>
              <div class="col-6" v-if="data.airport.city.timezone">
                <div class="card no-hover p-3 bg-blurry">
                  <p class="mb-1 small text-uppercase opacity-75">Huidige tijd</p>
                  <p class="mb-0 fw-bold mb-n1">{{ moment().tz(data.airport.city.timezone).format('HH:mm') }} ({{ moment.parseZone(moment().tz(data.airport.city.timezone)).format('Z') }})</p>
                </div>
              </div>
              <div class="col-6" v-if="weather?.current">
                <div class="card no-hover p-3 bg-blurry">
                  <p class="mb-1 small text-uppercase opacity-75">Huidig weer</p>
                  <p class="mb-0 fw-bold mb-n1">{{ weather.current.temperature_2m.toFixed() }} {{ weather.current_units.temperature_2m }} · {{ weather.current.wind_speed_10m.toFixed() }} {{ weather.current_units.wind_speed_10m }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <h2 class="h6 small fw-bold text-uppercase text-primary mb-3">
              Promo Rewards vanaf {{ data.airport.city.name_nl }}
            </h2>
            <PromoRewardCard
              v-if="
                data.promo_rewards.from_airport.some((x) => {
                  return (
                    x.end_booking_date ===
                    moment().endOf('month').format('MM/DD/YYYY')
                  );
                })
              "
              v-for="promoReward in data.promo_rewards.from_airport.filter(
                (x) => {
                  return (
                    x.end_booking_date ===
                    moment().endOf('month').format('MM/DD/YYYY')
                  );
                }
              )"
              :promo-reward="promoReward"
            />
            <div v-else class="alert alert-warning mb-0" role="alert">
              <p class="mb-0 small">
                Er zijn geen Flying Blue Promo Rewards deze maand vanaf {{ data.airport.city.name_nl }} ({{ data.airport.iata }}) met <a class="inherit" title="KLM" href="https://rewards.flights/nl/luchtvaartmaatschappijen/klm-royal-dutch-airlines">KLM</a> of <a class="inherit" title="Air France" href="https://rewards.flights/nl/luchtvaartmaatschappijen/air-france">Air France</a>.
              </p>
            </div>
          </div>
          <div class="col-12 mt-4" v-if="
                data.promo_rewards.from_airport.some((x) => {
                  return (
                    x.end_booking_date !==
                    moment().endOf('month').format('MM/DD/YYYY')
                  );
                })
              ">
            <h2 class="h6 small fw-bold text-uppercase text-primary mb-3">Verlopen aanbiedingen</h2>
            <PromoRewardCard
              :disabled="true"
              v-for="promoReward in data.promo_rewards.from_airport.filter(
                (x) => {
                  return (
                    x.end_booking_date !==
                    moment().endOf('month').format('MM/DD/YYYY')
                  );
                }
              ).slice(0,2)"
              :promo-reward="promoReward"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import moment from 'moment-timezone'
import 'moment/locale/nl';

definePageMeta({
  name: 'vluchten-vanaf'
})
const route = useRoute();

const runtimeConfig = useRuntimeConfig()

const {data} = await useAsyncData(
    'airport-' + route.params.iata,
    async () => {
      return $fetch(runtimeConfig.public.backendUrl + "/api/v2/airports/" + route.params.iata, {
        headers: {
          'User-Agent': 'RewardsFlightsFrontend/1.0 (https://rewards.flights)',
        }
      })
    }
);

const {data: weather} = useAsyncData(
    'airport-weather-' + route.params.iata,
    async () => {
      return $fetch(`https://api.open-meteo.com/v1/forecast?latitude=${data.value.airport.lat}&longitude=${data.value.airport.lng}&current=temperature_2m,wind_speed_10m`)
    }
);

useSeoMeta({
  title: "✈ Goedkope KLM vliegtickets vanaf " + data.value.airport.city.name_nl + " (" + data.value.airport.iata + ")",
  ogTitle: "✈ Goedkope KLM vliegtickets vanaf " + data.value.airport.city.name_nl,
  twitterTitle: "✈ Goedkope KLM vliegtickets vanaf " + data.value.airport.city.name_nl,
  description: "Promo Rewards vliegticket vanaf " + data.value.airport.name + " in " + data.value.airport.city.name_nl + ". Vluchten uitgevoerd door KLM / Air France en Skyteam partners.",
  ogDescription: "Promo Rewards vliegticket vanaf " + data.value.airport.name + " in " + data.value.airport.city.name_nl + ". Vluchten uitgevoerd door KLM / Air France en Skyteam partners.",
  twitterDescription: "Promo Rewards vliegticket vanaf " + data.value.airport.name + " in " + data.value.airport.city.name_nl + ". Vluchten uitgevoerd door KLM / Air France en Skyteam partners.",
  ogUrl: runtimeConfig.public.baseUrl + "/nl/vluchten-vanaf-" + data.value.airport.city.slug_nl + "-" + data.value.airport.iata.toLowerCase(),
  ogImage: data.value.airport.city.images.medium,
  twitterImage: data.value.airport.city.images.medium,
  twitterImageAlt: 'Foto van vliegveld ' + data.value.airport.name,
  ogLocale: "nl",
  ogLocaleAlternate: "en",
});

useHead({
  htmlAttrs: {
    lang: 'nl'
  },
  link: [
    {
      rel: "canonical",
      href: runtimeConfig.public.baseUrl + "/nl/vluchten-vanaf-" + data.value.airport.city.slug_nl + "-" + data.value.airport.iata.toLowerCase()
    },
    {
      rel: "alternate",
      hreflang: "x-default",
      href: runtimeConfig.public.baseUrl + "/flights-from-" + data.value.airport.city.slug_en + "-" + data.value.airport.iata.toLowerCase()
    },
    {
      rel: "alternate",
      hreflang: "en",
      href: runtimeConfig.public.baseUrl + "/flights-from-" + data.value.airport.city.slug_en + "-" + data.value.airport.iata.toLowerCase()
    },
    {
      rel: "alternate",
      hreflang: "nl",
      href: runtimeConfig.public.baseUrl + "/nl/vluchten-vanaf-" + data.value.airport.city.slug_nl + "-" + data.value.airport.iata.toLowerCase()
    }
  ],
});

useJsonld(() => {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: runtimeConfig.public.baseUrl + '/nl',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: data.value.airport.city.name_nl,
          },
        ],
      }
    ]
  }
});

useJsonld(() => {
  if (!data.value.airport) {
    return null;
  }
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Airport',
        name: data.value.airport.name_en,
        iataCode: data.value.airport.iata,
        icaoCode: data.value.airport.icao,
        openingHours: "Mo-Su",
        publicAccess: true,
        keywords: data.value.airport.city.name + ', ' + data.value.airport.iata + ', ' + data.value.airport.name + ', airport',
        address: [{
          '@type': 'PostalAddress',
          streetAddress: data.value.airport.address,
          addressLocality: data.value.airport.city.name,
          postalCode: data.value.airport.postal,
          addressCountry: data.value.airport.city.country.cca2,
        }],
        geo: [{
          '@type': 'GeoCoordinates',
          latitude: data.value.airport.lat,
          longitude: data.value.airport.lng,
        }],
        image: [data.value.airport.city.images.medium],
        url: data.value.airport.website,
        telephone: data.value.airport.phone,
        sameAs: [
          ...(data.value.airport.instagram_handle ? ['https://instagram.com/' + data.value.airport.instagram_handle] : []),
          ...(data.value.airport.x_handle ? ['https://x.com/' + data.value.airport.x_handle] : []),
          ...(data.value.airport.facebook_handle ? ['https://facebook.com/' + data.value.airport.facebook_handle] : []),
        ]
      }
    ]
  };
});
</script>
